export type TElementModuleOptions = {
  id: number;
  is_active: boolean;
  sub_type: string;
  element_id: number;
  option_id: number;
  category: string;
}
export type TModuleOptions = {
  id: number;
  key: string;
  type: string;
  company_id: number;
  legal_code?: string;
  module_id: number | null;
  string_value: string;
  numeric_value: number;
  show: boolean;
}

export type TTaxResume = {
  id: number,
  key:string,
  description:string,
  tax_amount:number
}

export type TMovementElementItem ={
  document_id:number
  id:number
  uid:string
  key:string
  register_type:string
  total_tax_amount:number
  taxes_list:TTaxResume[]
  module_options:Partial<TElementModuleOptions>[]
  register:number
  custom_id:string
  quantity_available:number
  display:string
  unit_price:number
  quantity:number
  name:string
  measure_unit:string
  element_id?:number
  item_name:string
  item_code:string
  item_description:string
  total_amount:number
  total_amount_full:number
  total_amount_net:number
  discount_amount:number
  discount_rate:number
  unit_cost?:number
  total_cost?:number
  purchase_price?:number
  taxes?:any
  stock_override?:boolean
  stock_override_reason?:string
  track_inventory?:boolean
  is_custom_charge?:boolean
}
export type TPayment = {
  id: number,
  document_id: number,
  payment_method: string,
  payment_method_code?: string,
  amount: number,
  reference?: string,
  payment_date?: string,
  created_at?: string,
  notes?: string
}

export type TSaleMovement = {
  approved_by_user_id:number
  created_by_user_id: number
  delivered_by_user_id: number
  received_by_user_id:number
  contact_id?:number
  company_id:number
  company_uid?:string
  companies?: { id?: number; uid?: string; name?: string } | null
  document_number:string
  notes?: string
  id:number
  internal_notes?: string
  correction_note_reason_code?:string
  document_type:  'PURCHASE_REQUEST' | 'PURCHASE_ORDER' | 'PURCHASE_RECEIPT' | 'SALE_INVOICE' | 'TRANSFER' | 'ADJUSTMENT' | 'RETURN_IN' | 'RETURN_OUT' | 'INITIAL_INVENTORY' | 'PARTNER_CONTRIBUTION' | 'PRODUCTION_ENTRY' | 'PRODUCTION_EXIT' | 'QUOTATION' | 'WASTE' | 'CREDIT_NOTE' | 'DEBIT_NOTE'
  invoice_type:  "CREDIT_NOTE" | "DEBIT_NOTE" | 'ELECTRONIC_INVOICE' | 'SIMPLE_RECEIPT' | 'POS_RECEIPT'
  status: 'DRAFT' | 'PENDING' | 'APPROVED' | 'COMPLETED' | 'CANCELLED' | 'REJECTED' | 'EXPIRED'
  payment_term: 'CASH' | 'CREDIT'
  credit_days:number
  credit_due_date:string
  reference_document?:string
  total_amount:number
  total_cost?:number
  accounting_status?: 'PENDING' | 'PROCESSED' | 'FAILED' | 'IGNORED' | null
  accounting_entry_id?: number | null
  cash_return_amount: number,
  cash_session_id?: number,
  storehouse_from_id?: number,
  storehouse_to_id?: number,
  stock_override?: boolean,
  stock_override_reason?: string,
  stock_override_by_user_id?: number,
  electronic_invoice_status?: 'PENDING' | 'SENT' | 'ACCEPTED' | 'REJECTED' | null,
  electronic_invoice_uuid?: string | null,
  electronic_invoice_number?: string | null,
  electronic_invoice_cufe?: string | null,
  electronic_invoice_qr_url?: string | null,
  electronic_invoice_public_url?: string | null,
  electronic_invoice_validated_at?: string | null,
  electronic_invoice_errors?: any,
  electronic_invoice_send_email?: boolean | null,
  document_date?: string | null,
  execution_mode?: 'IMMEDIATE' | 'DEFERRED' | null,
  reception_status?: 'PENDING' | 'PARTIALLY_RECEIVED' | 'RECEIVED' | null,
  payment_status?: 'UNPAID' | 'PARTIALLY_PAID' | 'PAID',
  settlement_status?: 'OPEN' | 'SETTLED',
  total_paid_amount?: number,
  balance_due_amount?: number,
  events?: any[],
  updated_at:string
  created_at: string
  uid:string
}

export type TNumberingRange = {
  id?: number;
  company_id: number;
  factus_range_id?: number | null;
  prefix: string;
  resolution_number?: string | null;
  resolution_date?: string | null;
  from_number: number;
  to_number: number;
  current_number?: number | null;
  valid_from?: string | null;
  valid_to?: string | null;
  document_type?: 'INVOICE' | 'CREDIT_NOTE' | 'DEBIT_NOTE';
  is_active?: boolean;
  is_default?: boolean;
  created_at?: string;
  updated_at?: string;
};

export type IMovementRS = TSaleMovement & {
  approved_by_user_name?:string
  approved_by_user_document?:string
  created_by_user_name?:string
  created_by_user_document?:string
  delivered_by_user_name?:string
  delivered_by_user_document?:string
  received_by_user_name?:string
  received_by_user_document?:string
  correction_note_reason_key: string
  correction_note_reason_description: string
  contact_name?:string
  contact_document?:string
  total_tax_amount:number
  total_discount_amount:number
  total_amount_full?:number
  total_amount_net?:number
  item_list: TMovementElementItem[],
  cash_session_uid?: string,
  reference_document_uid?: string,
  payments: Partial<TPayment>[],
  taxes_list: TTaxResume[],
  pos_name?:string
  pos_uid?:string
  items:number
  type:string
}

export interface Sale {
  item_list: TMovementElementItem[];
  showAddItem: boolean;
  showBill: boolean;
  showBillDetail:boolean;
  editableQuantityField: number;
  editableDiscountField: number;
  pendingList: IMovementRS[];
  billList: IMovementRS[];
  currentSubtotal: number;
  currentPending: Partial<IMovementRS> | null
  currentBill: IMovementRS | null;
  datePickerFilter: string[]
}

export const defaultSaleValues:Sale = {
  item_list: [],
  showAddItem: false,
  showBill: false,
  showBillDetail:false,
  editableQuantityField: -1,
  editableDiscountField: -1,
  pendingList: [],
  billList: [],
  currentSubtotal: 0,
  currentPending: null,
  currentBill: null,
  datePickerFilter: ["",""]
}

export interface TReceiptItem {
  product: string;
  quantity: number;
  price: number;
  total: number;
  discount: number;
  taxAmount: number;
  baseAmount: number;
}

export interface TReceiptData {
  receiptId: string;
  date: string;
  customer: string;
  seller: string;
  pdv: string;
  items: TReceiptItem[];
  subtotal: number;
  tax: number;
  total: number;
  totalDiscount: number;
  companyName: string;
  companyAddress: string;
  taxesList: TTaxResume[]
  message?: string;
  documentTitle: string;
  counterpartyLabel: string;
  userLabel: string;
}